import { TrackRound } from "model/Match/Track/TrackRound";
import { mapRoundTimes } from "./FsRoundTime";
import { nonUndefined } from "Utility";
import { FsTrackRound } from "db/model/match/Track/FsTrackRound";

export const mapTrackRounds = (fsModels: FsTrackRound[]): TrackRound[] => {
  return nonUndefined(fsModels.map(mapTrackRound));
};

const mapTrackRound = (fsModel: FsTrackRound): TrackRound | undefined => {
  const times = mapRoundTimes(nonUndefined(fsModel.times ?? []));
  if (times.every((t) => t.finishTimeMs === -1)) {
    return undefined;
  }

  return {
    golden: fsModel.golden,
    times,
  };
};
